import useSectorRoles from "@/hooks/useSectorRoles";
import useCandidateGraduateRoles from "@/hooks/useCandidateGraduateRoles";
import { Tagline } from "@/ui/Tagline";
import cn from "classnames";
import { useState } from "react";
import { Button, Col, Container, ListGroup, Row } from "react-bootstrap";

import classes from "./styles.module.scss";

export default function ({
  className = "py-5 py-md-6",
  tagline,
  title,
  description,
  lg = 3,
  EditableText,
  EditableHtml,
  theme = "light",
  Sector_id,
  sector_page = true,
  candidate_graduate_roles_page = false
}) {

  const allPosts = candidate_graduate_roles_page
    ? useCandidateGraduateRoles()
    : useSectorRoles();


  const posts = candidate_graduate_roles_page
    ? allPosts // Skip filtering if candidate_graduate_roles_page is true
    : allPosts.filter((post) => post.sector_page?.includes(Sector_id));

  const [visibleCount, setVisibleCount] = useState(16);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleViewMore = () => {
    setVisibleCount(posts.length);
    setIsExpanded(true);
  };

  const handleViewLess = () => {
    setVisibleCount(16);
    setIsExpanded(false);
  };

  return (
    <div className={cn(className, classes.SectorRoles)} data-bs-theme={theme}>
      <Container fluid="md">
        <Tagline as={EditableText} path="tagline" tag="strong" className="d-block mb-3">
          <span dangerouslySetInnerHTML={{ __html: tagline }} />
        </Tagline>
        <EditableText path="title" tag="h2">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </EditableText>
        {description && (
          <EditableHtml path="description">
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </EditableHtml>
        )}
        <Row>
          {posts.slice(0, visibleCount).map((post, idx) => (
            <Col xs={12} sm={6} lg={lg} key={post.id || idx}>
              <ListGroup>
                <ListGroup.Item>{post.role ? post.role : post.title}</ListGroup.Item>
              </ListGroup>
            </Col>
          ))}
        </Row>

        <div className={cn(className, classes.call_to_action)}>
          {isExpanded ? (
            <Button onClick={handleViewLess} variant="secondary" aria-label="View less roles">
              View Less
            </Button>
          ) : (
            visibleCount < posts.length && (
              <Button onClick={handleViewMore} variant="secondary" aria-label="View more roles">
                View More
              </Button>
            )
          )}
        </div>
      </Container>
    </div>
  );
}
